import { HttpClient } from '@/components/shared/http-client'

async function downloadDocument(accountCode, documentIdentifier) {
  const url = `/api/documents/${accountCode}/download/${documentIdentifier}`
  // { data, headers }
  const response = await HttpClient.get(url, { responseType: 'blob' })
  return response
}
function downloadFileToClient(file, filename) {
  const link = document.createElement('a')
  link.setAttribute('download', filename)
  link.href = window.URL.createObjectURL(file)
  document.body.appendChild(link)
  link.click()
  link.remove()
}
async function getAccountDocumentFile(accountCode, documentIdentifier) {
  const { data, headers } = await downloadDocument(accountCode, documentIdentifier)
  const { 'content-disposition': contentDisposition = '' } = headers || {}
  const filename = contentDisposition.replace(/^attachment; filename=/i, '')
  const blob = new Blob([data])
  return {
    filename,
    blob,
  }
}
async function getAndDownloadToClient(accountCode, documentIdentifier) {
  const { data, headers } = await downloadDocument(accountCode, documentIdentifier)
  const { 'content-disposition': contentDisposition = '' } = headers || {}
  const fileName = contentDisposition.replace(/^attachment; filename=/i, '')
  downloadFileToClient(new Blob([data]), fileName)
}

export { downloadDocument, downloadFileToClient, getAndDownloadToClient, getAccountDocumentFile }
